import { type CenterProps } from '@react-three/drei'
import { Select } from '@react-three/postprocessing'

import { BOX_GEOMETRY, METAL_MATERIAL, WOOD_MATERIAL, WOOD_MATERIAL_LIGHT } from '@utils'

type SplineModelProps = CenterProps & {
  isSwitch?: boolean
  highlight?: boolean
}

export function SplineModel({ isSwitch, highlight = false, ...props }: SplineModelProps) {
  return (
    <group {...props}>
      <Select enabled={highlight}>
        <mesh
          receiveShadow
          scale={[isSwitch ? 0.4 : 0.5, 0.05, 0.12]}
          position-y={-0.01}
          geometry={BOX_GEOMETRY}
          material={isSwitch ? WOOD_MATERIAL_LIGHT : WOOD_MATERIAL}
        />
      </Select>
      <mesh
        receiveShadow
        scale={[0.04, 0.03, 0.05]}
        position={[0.17, 0.02, 0]}
        geometry={BOX_GEOMETRY}
        material={METAL_MATERIAL}
      />
      <mesh
        receiveShadow
        scale={[0.04, 0.03, 0.05]}
        position={[-0.17, 0.02, 0]}
        geometry={BOX_GEOMETRY}
        material={METAL_MATERIAL}
      />
    </group>
  )
}
